module.exports = __webpack_public_path__ + "geldteller_ill.jpg?c25acb355da67f7f6a879824a885d890";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placeholders/geldteller_ill.jpg
// module id = 607
// module chunks = 0